import type { SearchParamsRecord } from '../queryParams';
import { Exit, Schema } from 'effect';

import { alphabetFilterParamName, glossaryNameFilterParamName } from '../../config/urlParams';
import { AlphabetFilterSchema } from './alphabetFilter';

export { AlphabetFilterSchema };

export const NameFilterSchema = Schema.String.check(Schema.isNonEmpty()).annotate({
  identifier: 'GlossaryNameFilterSchema',
  description: 'Glossary term name search filter',
});

const decodeFilter = (
  schema: Schema.Codec<string, string>,
  raw: SearchParamsRecord[string]
): string | null =>
  Exit.match(Schema.decodeUnknownExit(schema)(raw), {
    onFailure: () => null,
    onSuccess: (value) => value,
  });

/**
 * Each filter is decoded on its own: an unusable `?alphabet=` must not discard
 * a usable `?name=` alongside it, which is what decoding the pair as one struct
 * would do. An undecodable value reads as absent — the URL is user input, not a
 * contract, so a bad one degrades to the unfiltered view rather than erroring.
 */
export const decodeGlossaryFiltersSearchParams = (searchParams: SearchParamsRecord) => ({
  alphabetFilter: decodeFilter(AlphabetFilterSchema, searchParams[alphabetFilterParamName]),
  nameFilter: decodeFilter(NameFilterSchema, searchParams[glossaryNameFilterParamName]),
});
